import { CapacitorAccess } from "../capacitor";
import { KeyboardInfo, VirtualKeyboardDef, KeyboardResizeMode } from "./VirtualKeyboardDef";

export class VirtualKeyboardAccessor implements VirtualKeyboardDef {
    private static _instance: VirtualKeyboardAccessor;
    private readonly _plugin: any; // Will be set to Capacitor Keyboard plugin

    private constructor() {
        this._plugin = CapacitorAccess.plugins?.Keyboard;
    }

    public static get instance(): VirtualKeyboardAccessor {
        this._instance ??= new VirtualKeyboardAccessor();
        return this._instance;
    }

    public async show(): Promise<void> {
        if (!this._plugin) return;
        await this._plugin.show();
    }

    public async hide(): Promise<void> {
        if (!this._plugin) return;
        await this._plugin.hide();
    }

    public async setResizeMode(mode: KeyboardResizeMode): Promise<void> {
        if (!this._plugin) return;
        await this._plugin.setResizeMode({ mode });
    }

    public addWillShowListener(callback: (info: KeyboardInfo) => void): () => void {
        if (!this._plugin) return () => {};
        const listener = this._plugin.addListener('keyboardWillShow', callback);
        return () => { listener.remove(); };
    }

    public addDidShowListener(callback: (info: KeyboardInfo) => void): () => void {
        if (!this._plugin) return () => {};
        const listener = this._plugin.addListener('keyboardDidShow', callback);
        return () => { listener.remove(); };
    }

    public addWillHideListener(callback: () => void): () => void {
        if (!this._plugin) return () => {};
        const listener = this._plugin.addListener('keyboardWillHide', callback);
        return () => { listener.remove(); };
    }

    public addDidHideListener(callback: () => void): () => void {
        if (!this._plugin) return () => {};
        const listener = this._plugin.addListener('keyboardDidHide', callback);
        return () => { listener.remove(); };
    }
}
